import { useEffect } from 'react';
import api from '../utils/api';

export default function KeepAlive() {
  useEffect(() => {
    const ping = () => api.get('/ping').catch(() => {});
    ping();
    const interval = setInterval(ping, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  return null;
}
